@if (chartOptions && !loading) {
<div class="genericGraph">
<!--  <div #graphDisplay class="graph-display">-->
    @if (!isTableView) {
<apx-chart
      [series]="chartOptions.series"
      [chart]="chartOptions.chart"
      [xaxis]="chartOptions.xaxis"
      [stroke]="chartOptions.stroke"
      [colors]="chartOptions.colors"
      [dataLabels]="chartOptions.dataLabels"
      [plotOptions]="chartOptions.plotOptions"
      [legend]="chartOptions.legend"
      [fill]="chartOptions.fill"
      [markers]="chartOptions.markers"
      [grid]="chartOptions.grid"
      [yaxis]="chartOptions.yaxis"
      [title]="chartOptions.title"
    ></apx-chart>
}
    @if (isTableView) {
<tools-table
      #tableView
      [Headers]="tableViewHeaders"
      [Multiple]="false"
      [SelectAll]="false"
      [Selectable]="false"
      [Search]="false"
      [Data]="tableViewData"
      [Slim]="true"
      [DataCount]="tableViewData.length"
      [DisplayCount]="5"
      [PrimaryColumn]="'Time'"
      [HasCustomPaginator]="true"
      class="cdr_table">
    </tools-table>
}
  </div>
}
<!--</div>-->

@if (loading) {
<div>
  <mat-spinner class="mainSpinner"></mat-spinner>
</div>
}
